<script lang="ts" setup>
withDefaults(
  defineProps<{
    title: string,
    text?: string,
    alert?: boolean,
    hideCard?: boolean
  }>(),
  {
    text: '',
    alert: () => false,
    hideCard: () => false
  }
)
</script>

<template>
  <div :class="{ 'card': !hideCard }" class="steps-table__excluded-info excluded-info">
    <div v-if="alert" class="excluded-info__icon alert">
      <i class="ic-alert" />
    </div>

    <div v-else class="excluded-info__icon">
      <i class="ic-info-circle" />
    </div>

    <div class="excluded-info__content">
      <div class="h3">
        {{ title }}
      </div>
      <span v-if="text">
        {{ text }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.excluded-info {
  padding: rem-calc(19) rem-calc(24);
  display: flex;
  align-items: center;

  @include media('>=desktop') {
    padding: rem-calc(32);
  }

  &__icon {
    width: rem-calc(64);
    height: rem-calc(64);
    background: $borderColor;
    border-radius: 50%;
    margin-right: 24px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    i[class^='ic-'] {
      font-size: rem-calc(42);
    }

    &.alert {
      background: none;
      color: $vaSecondaryColor;
    }
  }
}
</style>
